import React from "react";
import "./PrintCardPreview.css";
import { logoUrl } from "config/CONSTANTS";
import { urlBadge } from "services/CONSTANTS";

const PrintCardPreview = ({ idData, printHeader, subHeader, issueDate, expDate, clubLogoUrl }) => {
    if (!idData) return null;

    const {
        firstName,
        lastName,
        dob,
        issuedDate,
        expiresDate,
        address,
        city,
        state,
        zip,
        image,
        idNumber,
        classification,
    } = idData;

    // Determine subheader
    const defaultSubHeader = classification === "Resident" ? "Resident Card" : "Employee ID";
    const displaySubHeader = subHeader || defaultSubHeader;

    // Format address
    const addressLine1 = address || '';
    const addressLine2 = [city, state, zip].filter(Boolean).join(', ');

    // Print CSS for CR-80 card size (86mm x 54mm)
    const printStyle = `
      @media print {
        body * {
          visibility: hidden !important;
        }
        #print-area, #print-area * {
          visibility: visible !important;
        }
        #print-area {
          position: absolute !important;
          left: 0; top: 0;
          width: 86mm;
          height: 54mm;
          margin: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          background: white !important;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        @page {
          size: 86mm 54mm;
          margin: 0;
        }
      }
    `;

    return (
        <>
          <style>{printStyle}</style>
          <div id="print-area" className="print-card-wrapper" style={{ borderRadius: '2mm', border: '0.5mm solid #337ab7', overflow: 'hidden', width: '86mm', height: '54mm', fontFamily: 'sans-serif', background: '#fff', position: 'relative', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <div className="print-card-header" style={{ background: '#56B8FF', color: '#111', padding: '0.7mm 0 0.7mm 0', textAlign: 'center', fontWeight: 'bold', fontSize: '6mm', letterSpacing: '0.2mm' }}>{printHeader}</div>
            <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
              {/* Left/photo area */}
              <div style={{ width: '26mm', background: '#f3eacb', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', borderRight: '0.4mm solid #000', position: 'relative', paddingTop: '3mm' }}>
                    {image ? (
                        <img 
                            src={`${urlBadge}/${image}`} 
                            alt="ID Photo" 
                    style={{ width: '21mm', height: '21mm', objectFit: 'cover', border: '0.5mm solid #222', background: '#fff', borderRadius: '1mm', marginBottom: '4mm' }}
                        />
                    ) : (
                  <div style={{ width: '21mm', height: '21mm', background: '#eee', border: '0.5mm solid #222', borderRadius: '1mm', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', marginBottom: '4mm', fontSize: '3mm' }}>Photo</div>
                )}
              </div>
              {/* Right/info area */}
              <div style={{ flex: 1, position: 'relative', padding: 0, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
                {/* Subheader (inside right section, full width) */}
                <div style={{ background: '#C0DEEA', color: '#222', fontSize: '4mm', fontWeight: 600, padding: '0.4mm 0 0.4mm 0', borderRadius: '0', width: '100%', textAlign: 'center' }}>{displaySubHeader}</div>
                {/* Watermark centered in info area below subheader */}
                <div style={{ position: 'absolute', top: '56%', left: '50%', transform: 'translate(-50%, -50%)', width: '70%', height: '60%', opacity: 0.35, zIndex: 0, pointerEvents: 'none' }}>
                  <img src={clubLogoUrl || logoUrl} alt="Watermark" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
                {/* Info wrapper: flex column, grow to fill, with divider centered */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                  {/* Info Part 1 */}
                  <div style={{ flex: 1, padding: '2.2mm 4mm 0 1.5mm', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', position: 'relative', zIndex: 1 }}>
                    {/* Name */}
                    <div style={{ fontWeight: 'bold', fontSize: '3.5mm', zIndex: 1, position: 'relative', lineHeight: '1.1' }}>{firstName} {lastName}</div>
                    {/* Info (DOB, Issued, Expires) */}
                    <div style={{ fontSize: '3.5mm', marginTop: '0.8mm', zIndex: 1, position: 'relative', marginBottom: '-2mm' }}>
                    {classification === "Resident" && (
                        <>
                          <div><strong>DOB:</strong> {dob}</div>
                          <div><strong>Issued:</strong> {issueDate}</div>
                          <div><strong style={{ color: 'red' }}>Expires:</strong> <span style={{ color: '#222' }}>{expDate}</span></div>
                        </>
                    )}
                    {classification === "Employee" && (
                        <div><strong>Issued:</strong> {issueDate}</div>
                    )}
                    </div>
                  </div>
                  {/* Divider (horizontal line, centered) */}
                  <div style={{ borderBottom: '0.4mm solid #000', width: '100%', margin: '1mm 0' }} />
                  {/* Info Part 2: Address */}
                  <div style={{ flex: 1, padding: '0 4mm 0 1.5mm', fontSize: '2.7mm', zIndex: 1, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                    <div>{addressLine1}</div>
                    <div>{addressLine2}</div>
                  </div>
                  {/* ID number at bottom right */}
                  <div style={{ position: 'absolute', bottom: '2mm', right: '2mm', fontSize: '3mm', color: '#333', fontWeight: 600, zIndex: 1 }}>#{idNumber || "000000"}</div>
                </div>
            </div>
            </div>
        </div>
        </>
    );
};

export default PrintCardPreview;
